import React, { useState } from "react";
import EmptyView from "./EmptyView";
import DataBox from "./DataBox";
import { ASSETS } from "../../../utils/config";
import { SocialIcons, SocialLinks } from "../../../utils/socialHelpers";
import IyugaBusinessBoxSVG from "@assets/images/iyugaBusinessBox.svg";
import Fb from "@assets/images/FbBBDefault.svg";
import Youtube from "@assets/images/YoutubeBBDefault.svg";
import Instagram from "@assets/images/InstagramBBDefault.svg";
import LinkedIn from "@assets/images/LinkedInBBDefault.svg";
import Website from "@assets/images/globe 1.svg";

const defaultIcons = [
  {
    id: 72,
    icon: Fb,
    link: "https://www.facebook.com/iyugawheel",
    is_cta_enabled: true,
  },
  {
    id: 73,
    icon: Youtube,
    link: "https://www.youtube.com/@iYugawheel",
    is_cta_enabled: true,
  },
  {
    id: 74,
    icon: Instagram,
    link: "https://www.instagram.com/iyugawheel/",
    is_cta_enabled: true,
  },

  {
    id: 79,
    icon: LinkedIn,
    link: "https://www.linkedin.com/company/iyuga/",
    is_cta_enabled: true,
  },
  {
    id: 80,
    icon: Website,
    link: "https://iyuga.net",
    is_cta_enabled: true,
  },
  // {
  //   id: 1,
  //   src: ASSETS.profileFacebook,
  //   link: "https://www.facebook.com/doterra",
  //   icon: SocialIcons[SocialLinks.facebook],
  // },
  // {
  //   id: 2,
  //   src: ASSETS.youtubeIcon,
  //   link: "https://www.youtube.com/channel/UCOfpaxKnF8fqjRg05TGNHZQ",
  //   icon: SocialIcons[SocialLinks.youtube],
  // },
  // {
  //   id: 3,
  //   src: ASSETS.bb_social_instagram,
  //   link: "https://www.instagram.com/doterra/?hl=en",
  //   icon: SocialIcons[SocialLinks.instagram],
  // },
  // {
  //   id: 4,
  //   src: ASSETS.segmentEditor.PincentIcon,
  //   link: "https://www.pinterest.com/doTERRA/",
  //   icon: SocialIcons[SocialLinks.pinterest],
  // },
  // {
  //   id: 5,
  //   src: ASSETS.bb_social_linkedin,
  //   link: "https://www.linkedin.com/company/d-terra/",
  //   icon: SocialIcons[SocialLinks.linkedin],
  // },
  // { id: 1, src: ASSETS.segmentEditor.AtTheRate },
  // { id: 4, src: ASSETS.segmentEditor.MessengerIcon },
  // { id: 5, src: ASSETS.segmentEditor.UkIcon },
  // { id: 6, src: ASSETS.segmentEditor.TwitterIcon },
];

export const BusinessBoxDefaultData = {
  imageSrc: IyugaBusinessBoxSVG,
  business_title: `<p style="font-family: 'DM Sans'; font-weight: 700; font-size: 30px; line-height: 30px; letter-spacing: -2%; text-align: center; color: #123051;">iYuga Business Box!</p>`,

  description: `<p style="font-family: 'DM Sans'; font-weight: 500; font-size: 16px; line-height: 24px; letter-spacing: -1%; text-align: center; color: #666E65; margin: 0;">Want to showcase your business, services, or favorite things like a non-profit, product, or project?<br><br>Upgrade to a Premium or higher subscription and build your very own Business Box today!</p>`,

  // ctaButtons: [
  //   {
  //     id: 9,
  //     title:
  //       '<div style="font-size: 16px; font-family: &quot;DM Sans&quot;;"><div style="font-size: 16px; font-family: &quot;DM Sans&quot;;"><p>Upgrade Now</p></div></div>',
  //     link: "iyuga.net",
  //     is_cta_enabled: true,
  //   },
  //   {
  //     id: 10,
  //     title:
  //       '<div style="font-size: 16px; font-family: &quot;DM Sans&quot;;"><div style="font-size: 16px; font-family: &quot;DM Sans&quot;;"><p>Join a Live Presentation</p></div></div>',
  //     link: "https://link.iyuga.net/widget/bookings/iyuga-presentation",
  //     is_cta_enabled: true,
  //   },
  // ],
  icons: defaultIcons,
};
const BusinessBox = ({ onBboxEdit }) => {
  const [isShowEmpty] = useState(false);
  return isShowEmpty ? (
    <EmptyView />
  ) : (
    <DataBox
      data={BusinessBoxDefaultData}
      isGalleryBbox
      onBboxEdit={onBboxEdit}
      isDefault
    />
  );
};

export default BusinessBox;
